const bookPriceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatBookPrice(value: number): string {
  return bookPriceFormatter.format(value);
}

/** Key of one grid cell: a (category, class) pair. */
export function pcmpPriceKey(categoryId: number, classId: number): string {
  return `${categoryId}:${classId}`;
}
